module.exports = __webpack_public_path__ + "img/area-image.7bc32019.png";